// extracted by mini-css-extract-plugin
export default {"checkbox":"SelectedFalse_checkbox__zlUo7","label":"SelectedFalse_label__JCniu","selectedfalse":"SelectedFalse_selectedfalse__1eedk"};